// -- REST endpoints -------------------------------------------------------

export const ORG_ROLES_ENDPOINT = (organizationId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/roles`;

export const ORG_ROLE_ENDPOINT = (organizationId: string, roleId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/roles/${encodeURIComponent(roleId)}`;

export const ORG_SERVICES_ENDPOINT = (organizationId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/services`;

export const ORG_MEMBERS_ENDPOINT = (organizationId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/members`;

export const ORG_MEMBER_ENDPOINT = (organizationId: string, memberId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/members/${encodeURIComponent(memberId)}`;

export const ORG_INVITATIONS_ENDPOINT = (organizationId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/invitations`;

export const ORG_INVITATION_ENDPOINT = (organizationId: string, invitationId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/invitations/${encodeURIComponent(invitationId)}`;

export const ORG_INVITATION_RESEND_ENDPOINT = (organizationId: string, invitationId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/invitations/${encodeURIComponent(invitationId)}/resend`;

export const ORG_USAGE_ENDPOINT = (organizationId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/usage`;

export const ORG_USAGE_REPORT_ENDPOINT = (organizationId: string, days: number) =>
  `/orgs/${encodeURIComponent(organizationId)}/usage/report?days=${days}`;

// Observability-backed (`observability_events`) — distinct data source from
// ORG_USAGE_REPORT_ENDPOINT above, same REST namespace.
export const ORG_USAGE_SERVICE_REPORT_ENDPOINT = (organizationId: string, days: number) =>
  `/orgs/${encodeURIComponent(organizationId)}/usage/service_report?days=${days}`;

// Per-member version of the same observability data.
export const ORG_USAGE_SERVICE_REPORT_USERS_ENDPOINT = (organizationId: string, days: number) =>
  `/orgs/${encodeURIComponent(organizationId)}/usage/service_report/users?days=${days}`;

export const ORG_MEMBER_USAGE_ENDPOINT = (organizationId: string, userId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/usage/members/${encodeURIComponent(userId)}`;

export const ORG_MEMBER_USAGE_BUDGET_ENDPOINT = (organizationId: string, userId: string) =>
  `/orgs/${encodeURIComponent(organizationId)}/usage/members/${encodeURIComponent(userId)}/budget`;

// -- GraphQL — member lifecycle (active/deactivated) ----
// Role (re)assignment lives on the REST surface above (useAssignMemberRole) — the
// equivalent GraphQL mutation was retired since it drives the same backend operation.

export const DEACTIVATE_ORG_USER_MUTATION = `
  mutation DeactivateOrgUser($input: OrgUserIdInput!) {
    deactivateOrgUser(input: $input) {
      memberId
      organizationId
      userId
      role
      status
      deactivatedAt
      deactivatedByUserId
    }
  }
`;

export const REACTIVATE_ORG_USER_MUTATION = `
  mutation ReactivateOrgUser($input: OrgUserIdInput!) {
    reactivateOrgUser(input: $input) {
      memberId
      organizationId
      userId
      role
      status
      deactivatedAt
    }
  }
`;
